import { render, staticRenderFns } from "./View1.vue?vue&type=template&id=6a849895&scoped=true"
import script from "./View1.vue?vue&type=script&lang=js"
export * from "./View1.vue?vue&type=script&lang=js"
import style0 from "./View1.vue?vue&type=style&index=0&id=6a849895&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a849895",
  null
  
)

export default component.exports